import { useCallback } from 'react'

import { useModalStore } from '@features/modal'

import AddressPickerModal from '../ui/AddressPickerModal'

import styles from '../ui/AddressPickerModal.module.scss'

type AddressPickerModalProps = {
  onClose?: () => void
  onOpen?: () => void
}

export default function useAddressPickerModal ({ onClose, onOpen }: AddressPickerModalProps = {}) {
  const { openModal, closeModal } = useModalStore()

  const handleClose = useCallback(() => {
    closeModal('orderAddress')

    if (onClose) {
      onClose()
    }
  }, [ onClose, closeModal ])

  return {
    openAddressPickerModal: () => {
      openModal('orderAddress', <AddressPickerModal onClose={handleClose} />, {
        hideIconClose: true,
        classes: {
          content: styles.modalContent,
          body: styles.modalBody,
        },
      })

      if (onOpen) {
        onOpen()
      }
    },
    closeAddressPickerModal () {
      closeModal('orderAddress')
    }
  }
}
